import axios from "axios";

export const on = (eventName: string, selector: string|null, action: CallableFunction) => {
    document.addEventListener(eventName, event => {
        if (selector === null && action !== null) {
            return action(event);
        }
        const target = event.target as HTMLElement;
        const element: HTMLElement | null = target.closest(selector);
        if (element !== null && action !== null) {
            return action(event, element);
        }
        return true;
    });
};

export const imageUpload = (file: string | Blob, onload: CallableFunction) => {
    axios({
        method: 'get',
        url: '/control/image/csrf',
    }).then(result => {
        const data = new FormData();
        data.append('image[item]', 'images');
        data.append('image[file]', file);
        data.append('image[_token]', result.data);
        axios({
            method: 'post',
            url: '/control/image/create',
            data,
            headers: {'Content-Type': 'multipart/form-data'},
        }).then((result: any) => {
            if (!result.data.file || result.data.file === 'logo.webp') {
                return alert('Download image error');
            }
            const reader = new FileReader();
            reader.onload = () => {
                onload(result);
            };
            if (file instanceof Blob) {
                reader.readAsDataURL(file);
            }
        });
    });
};
